module.exports = __webpack_public_path__ + "img/title-2.0fa8bdbc.png";